import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import './Offer.scss';
import { urlFor, client } from '../../client';
import { images } from '../../constants';
import { FaAward } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { VscFolderLibrary } from 'react-icons/vsc'
import ME from '../../assets/profile.png'
import { MdEngineering } from 'react-icons/md'
import { BsDot } from 'react-icons/bs'
import { AiOutlineArrowRight, AiOutlineClose, AiOutlineCheck } from 'react-icons/ai'
import { GiSkills, GiFlexibleStar } from 'react-icons/gi'
import { Ri24HoursLine } from 'react-icons/ri'



const Offer = () => {
  const [style5, setStyle5] = useState('abouts__modal');

  const [style1, setStyle1] = useState('abouts__modal');

  const [style2, setStyle2] = useState('abouts__modal');

  const [style3, setStyle3] = useState('abouts__modal');

  const [style4, setStyle4] = useState('abouts__modal');



  const changeStyle1 = () => {
    setStyle1('abouts__modal-reveal')
  }

  const changeStyle2 = () => {
    setStyle2('abouts__modal-reveal')
  }

  const changeStyle3 = () => {
    setStyle3('abouts__modal-reveal')
  }

  const changeStyle4 = () => {
    setStyle4('abouts__modal-reveal')

  }

  const changeStyle5 = () => {
    setStyle5('abouts__modal-reveal')
  }

  const cancelStyle = () => {
    setStyle1('abouts__modal')
    setStyle2('abouts__modal')
    setStyle3('abouts__modal')
    setStyle4('abouts__modal')
    setStyle5('abouts__modal')
  }
  return (
    <section id='About'>
      <div className='top__titles'>
        <h2 className='head-text' >What I Offer</h2>

      </div>






      <div

        className="container about__container"
      >

        <div className='about__content'>
          <div className="about__cards">

            <article className='about__card'>
              <FaAward className='about__icon' />
              <div className='about__title'>
                <h3>BlockChain Development</h3>
                <p className='p-text'>Blockchain Implementaion </p>
              </div>
              <span className="about__button" onClick={changeStyle2}>
                See More <AiOutlineArrowRight className='about__icon1' />
              </span>

              <div className={style2}>
                <div className="abouts__modal-content">
                  <AiOutlineClose className='abouts__modal-close' onClick={cancelStyle} />

                  <h3 className="abouts__modal-title">
                    Web3 Dev
                  </h3>

                  <ul className="abouts__modal-list">
                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I build decentralized apps and smart contracts
                      </p>
                    </li>


                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I build blockchains and cryptocurrencies from scratch
                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I implement systems into the Blockchain technology.
                      </p>
                    </li>



                  </ul>

                </div>
              </div>
            </article>


            <article className='about__card'>
              <GiFlexibleStar className='about__icon' />
              <div className='about__title'>
                <h3>Web Development</h3>
                <p className='p-text'>Web Dev</p>
              </div>

              <span className="about__button" onClick={changeStyle3}>
                See more <AiOutlineArrowRight className='about__icon1' />
              </span>


              <div className={style3}>
                <div className="abouts__modal-content">
                  <AiOutlineClose className='abouts__modal-close' onClick={cancelStyle} />

                  <h3 className="abouts__modal-title">
                    Web Development
                  </h3>

                  <ul className="abouts__modal-list">
                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I create responsive websites using frontend frameworks and libraries like React, Next js, TailwindCSS, scss and more
                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I write clean and easy to understand codes in my development.
                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I implement quality user experience in my development.
                      </p>
                    </li>

                  </ul>

                </div>
              </div>
            </article>

            <article className='about__card'>
              <GiFlexibleStar className='about__icon' />
              <div className='about__title'>
                <h3>Web Design</h3>
                <p className='p-text'>UI/UX Services</p>
              </div>

              <span className="about__button" onClick={changeStyle3}>
                See more <AiOutlineArrowRight className='about__icon1' />
              </span>


              <div className={style3}>
                <div className="abouts__modal-content">
                  <AiOutlineClose className='abouts__modal-close' onClick={cancelStyle} />

                  <h3 className="abouts__modal-title">
                    Web Design
                  </h3>

                  <ul className="abouts__modal-list">
                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I design responsive websites for frontend developers using figma.
                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I also design responsive mobile apps designs for app developers.
                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I implement quality user experience in my designs
                      </p>
                    </li>

                  </ul>

                </div>
              </div>
            </article>

          </div>

        </div>

      </div>


    </section>
  );
};

export default AppWrap(
  MotionWrap(Offer, 'app__about'),
  'about',
  'app__whitebg',
);